



  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <!-- Brand Logo -->
    <a href="#/dashboard" class="brand-link">
      <img src="./assets/dist/img/logo_andrea.png" alt="AdminLTE Logo" class="brand-image img-circle elevation-3" style="opacity: .8">
      <span class="brand-text font-weight-light"> www.andreagt.com</span>
    </a>

    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar user panel (optional) -->
     

      <!-- SidebarSearch Form -->
     

      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          <!-- Add icons to the links using the .nav-icon class
               with font-awesome or any other icon font library -->
          <li class="nav-item menu-open">
            <a href="#" class="nav-link active">
              <i class="nav-icon fas fa-tachometer-alt"></i>
              <p>
                Opciones
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <a href="#/dashboard/categoria" class="nav-link active">
                  <i class="far fa-circle nav-icon"></i>
                  <p>Categoria</p>
                </a>
              </li>
              <li class="nav-item">
                <a href="#/dashboard/producto" class="nav-link">
                  <i class="far fa-circle nav-icon"></i>
                  <p>Producto</p>
                </a>
              </li>
              <li class="nav-item">
                <a href="#/dashboard/gestion-pedido" class="nav-link">
                  <i class="far fa-circle nav-icon"></i>
                  <p>Gestión pedidos</p>
                </a>
              </li>

              <li class="nav-item">
                <a href="#/dashboard/codigo-descuento" class="nav-link">
                  <i class="far fa-circle nav-icon"></i>
                  <p>Códigos Descuento</p>
                </a>
              </li>
            </ul>
          </li>

        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>

  <aside class="control-sidebar control-sidebar-dark">
    <!-- Control sidebar content goes here -->
  </aside>

<!-- <aside class="main-sidebar sidebar-dark-primary elevation-4">

    <a href="" class="brand-link">
    
      <span class="brand-text font-weight-light">www.andreagt.com</span>
    </a>

   


    <div class="sidebar">
   
      

     

      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          
          
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-tree"></i>
              <p>
                Catálogo
                <i class="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <a  routerLink="categoria" class="nav-link" >
                  <i class="far fa-circle nav-icon"></i>
                  <p>Categoria</p>
                </a>
              </li>
              <li class="nav-item">
                <a href="pages/UI/icons.html" class="nav-link">
                  <i class="far fa-circle nav-icon"></i>
                  <p>Marca</p>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="producto" class="nav-link" >
                  <i class="far fa-circle nav-icon"></i>
                  <p>Producto</p>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="gestion-pedido" class="nav-link" >
                  <i class="far fa-circle nav-icon"></i>
                  <p>Gestión pedidos</p>
                </a>
              </li>
              
             
            </ul>
          </li>
          
          
          <li class="nav-item">
            <a href="#/dashboard" class="nav-link" (click)="logout()">
              <i class="nav-icon fas fa-th"></i>
              <p>
               Salir
             
              </p>
            </a>
          </li>
          
          
         
        </ul>
      </nav>
     
    </div>
   
  </aside> -->